import { authGet } from '../adapter/autenticados'
import { API_HOST } from '../constants'
import { getCookie } from '../cookies'
import { UserInfoResponse, UserObject } from '../types/types'

/**
 * Obtém informações do usuário a partir de uma chamada assíncrona para o endpoint '/info'.
 *
 * @returns {Promise<UserInfoResponse>} Uma promessa que resolve para a resposta contendo as informações do usuário.
 *
 * O método realiza as seguintes etapas:
 * 1. Obtém o valor do cookie 'prev_session'.
 * 2. Se o cookie existir, adiciona um cabeçalho 'X-Global-Session-User-ID' com o valor do cookie.
 * 3. Faz uma requisição GET autenticada para o endpoint '/dashboard/v2/info' no host definido por `API_HOST`, incluindo o cabeçalho, se presente.
 * 4. Retorna a resposta da requisição como um objeto do tipo `UserInfoResponse`.
 */
export const getInfo = async (): Promise<UserInfoResponse> => {
  const cookie = getCookie('prev_session')
  let prev_session = {}
  if (cookie) {
    prev_session = { 'X-Global-Session-User-ID': cookie }
  }
  const response = await authGet('/dashboard/v2/info', API_HOST, {
    headers: {
      ...prev_session,
    },
  })
  return response?.data as UserInfoResponse
}

export const getContasInfo = async (): Promise<UserObject> => {
  const data = await authGet('/v1/contas/info')
  return data?.data as UserObject
}
